import type { IconSvgObject } from './types';

const TouchLocked02Icon: IconSvgObject = [
  ["path", { d: "M7.49986 14V3.75C7.49986 2.7835 8.28336 2 9.24986 2C10.2164 2 10.9999 2.7835 10.9999 3.75V9.5C12.498 9.43338 14.9754 9.72719 17 11.2476M7.5 22V20C7.5 20 5.6719 17.9105 5.17457 17.0914C4.53229 16.0336 3.67793 14.8916 4.12367 13.6086C4.62368 12.1694 7.5 10 7.5 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.5 15.5C15.5 14.6716 16.1716 14 17 14C17.8284 14 18.5 14.6716 18.5 15.5V17H15.5V15.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TouchLocked02Icon;
